import { Option } from "components/parts/Input/SelectBox/SelectBox";
import { PageLevel, useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React from "react";
import { useHistory } from "react-router";
import { ConsoleRoleType } from "types/graphqlapi";
import {
  getGroupSelectOptions,
  listGroupAffiliationUsersQuery,
  listManageUsersByGroupQuery,
  listManageUsersQuery,
  UserWithGroup,
} from "utils/apis/user";

export const useUserList = (): [UserWithGroup[] | undefined, () => void] => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const { setScreenName, selectedGroupId, setPageLevel, role } =
    useConsoleState();
  const [userList, setUserList] = React.useState<UserWithGroup[]>();
  const fetchUsers = async () => {
    try {
      const queryResult =
        role === ConsoleRoleType.ADMINISTRATOR
          ? await listManageUsersQuery()
          : role === ConsoleRoleType.ASMARQUSER
          ? await listGroupAffiliationUsersQuery()
          : role === ConsoleRoleType.GROUPMANAGER
          ? await listManageUsersByGroupQuery(selectedGroupId)
          : undefined;
      setUserList(queryResult || []);
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
      setLoading(false);
      history.replace("/auth/login");
    }
  };
  React.useEffect(() => {
    setScreenName("ユーザー管理");
    setPageLevel(PageLevel.userManagement);
    fetchUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [userList, fetchUsers];
};

export const useGroupSelectOptions = () => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const [groupList, setGroupList] = React.useState<Option[]>([]);

  React.useEffect(() => {
    const runListGroupsQuery = async () => {
      try {
        const queryResult = await getGroupSelectOptions();
        setGroupList(queryResult);
      } catch (e) {
        console.error(e);
        alert("エラーが発生しました。");
        setLoading(false);
        history.replace("/auth/login");
      }
    };
    runListGroupsQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [groupList];
};
